import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  StyledBoxNotification,
  StyledTitleNotification,
  StyledListNotification,
  StyledIconArrow,
  StyledIconCollapseNot,
  StyledIconNotList,
  StyledBoxIconNot,
  StyledEmpty
} from './style';

import { StyledIconNot } from '../../views/Header/style';

import { Back, Close, Envelope, Parcel } from '../../../../assets/images/index';

import Icon from '../Icon';

// HOC
import withOutsideClick from '../../views/Common/ClickOutside';

// Components
import ParcelNotifications from './ParcelNotifications';
import GeneralNotifications from './GeneralNotifications';

// API
import { getNotificationNoViewed } from '../../../utils/apiHeader';

// actions
import { saveNotifications } from '../../../actions/notifications';

// Constants
const TYPES_INFO = {
  CMS: {
    txt: 'Notificaciones Generales',
    icon: Envelope
  },
  PARCEL: {
    txt: 'Notificaciones de Paquetería',
    icon: Parcel
  },
  ALL: {
    txt: 'Notificaciones Totales',
    icon: Envelope
  }
};

const TITLES = {
  CMS: 'NOTIFICACIONES GENERALES',
  PARCEL: 'NOTIFICACIONES PAQUETERÍA',
  ALL: 'NOTIFICACIONES TOTALES'
};

const getNotificationCounter = list =>
  list.reduce((last, notification) => last + Number(notification.count), 0);
class AppNotifications extends Component {
  constructor(props) {
    super(props);

    const { title, notificationsList } = props;

    this.state = {
      title, // Title to show. It should be 'NOTIFICACIONES' or each type of notifications
      notificationToShow: null, // Notification type info to show
      notificationType: null,
      isLoading: false,
      page: 0,
      dataNotifications: notificationsList,
      notificationsCount: getNotificationCounter(notificationsList)
    };
  }

  componentWillReceiveProps(nextProps) {
    const { notificationsList } = this.props;
    const { notificationsList: nextNotificationsList } = nextProps;

    if (nextNotificationsList !== notificationsList) {
      this.setState({
        dataNotifications: nextNotificationsList,
        notificationsCount: getNotificationCounter(nextNotificationsList)
      });
    }
  }

  onScroll = ({ target }) => {
    const { notificationType, isLoading } = this.state;
    if (!isLoading && target.scrollTop >= (target.scrollHeight - 400) / 2) {
      this.setNotification(notificationType);
    }
  };

  onHandleClick() {
    this.setState({
      notificationToShow: null,
      notificationType: null,
      page: 0
    });

    this.props.onClickOutside();
  }

  setNotification = (notificationType = null) => {
    const { title, setNotificationToShow } = this.props;
    const { page, notificationToShow } = this.state;
    if (notificationType) {
      this.setState({ isLoading: true });
      // Fetch data for this notification
      getNotificationNoViewed(notificationType, page).then(res => {
        setNotificationToShow(res.content);
        // If the response is empty, return
        if (res.content.length === 0) {
          this.setState({ isLoading: false });
          return;
        }
        this.setState({
          notificationType,
          notificationToShow: notificationToShow
            ? notificationToShow.concat(res.content)
            : res.content,
          title: TITLES[notificationType],
          isLoading: false,
          page: page + 1
        });
      });
    } else {
      this.setState({
        notificationToShow: null,
        page: 0,
        title
      });
    }
  };

  // Used when notification data changes or when going back from specific notifications
  updateData = (notificationType = null) => {
    this.setState({
      page: 0,
      notificationToShow: null
    });

    this.setNotification(notificationType);
  };

  renderNotification = () => {
    const { notificationType, notificationToShow } = this.state;
    switch (notificationType) {
      case 'PARCEL':
        return (
          <ParcelNotifications
            data={notificationToShow}
            update={this.updateData}
          />
        );
      case 'CMS':
        return (
          <GeneralNotifications
            data={notificationToShow}
            update={this.updateData}
          />
        );
      default:
        return null;
    }
  };

  render() {
    const { className, show } = this.props;
    const {
      title,
      notificationToShow,
      dataNotifications,
      notificationsCount
    } = this.state;
    return (
      <Fragment>
        {notificationsCount > 0 && (
          <StyledIconNot
            numberNot={`+${notificationsCount}`}
            hover
            className="appNotifications-iconNot"
          />
        )}
        {show && (
          <StyledBoxNotification
            className={`${className} notification-box`}
            onScroll={this.onScroll}
          >
            <StyledIconCollapseNot
              className="notification-collapse"
              color="main"
              size="s"
              svg={Close}
              onClick={() => {
                this.onHandleClick();
              }}
            />
            <StyledTitleNotification className="notification-title-box">
              {notificationToShow && (
                <StyledIconArrow
                  onClick={e => {
                    e.stopPropagation();
                    this.updateData();
                  }}
                  size="xs"
                  color="dark"
                  svg={Back}
                />
              )}
              <span className={title}>{title}</span>
            </StyledTitleNotification>
            {notificationToShow
              ? this.renderNotification()
              : dataNotifications.map(notification => (
                  <StyledListNotification
                    className="btn-type-notification"
                    onClick={() =>
                      this.setNotification(notification.typeAppNotification)
                    }
                  >
                    <StyledBoxIconNot>
                      <Icon
                        size="l"
                        color="light"
                        svg={TYPES_INFO[notification.typeAppNotification].icon}
                      />
                      <StyledIconNotList numberNot={notification.count} />
                    </StyledBoxIconNot>
                    {TYPES_INFO[notification.typeAppNotification].txt}
                  </StyledListNotification>
                ))}
            {dataNotifications.length === 0 && (
              <StyledEmpty>No tienes ninguna notificación</StyledEmpty>
            )}
          </StyledBoxNotification>
        )}
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setNotificationToShow: notificationToShow =>
    saveNotifications(dispatch, notificationToShow)
});

const mapStateToProps = ({ notifications }) => ({
  notificationsList: notifications.notificationsList
});

AppNotifications.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  show: PropTypes.bool
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withOutsideClick(AppNotifications));
